import { ICompanyInfo } from 'types';
import { CANADA_ID, USA_ID } from './const';

export const isUpcEnabled = (company: ICompanyInfo | undefined) => {
    return company && (company.country_id === USA_ID || company.country_id === CANADA_ID);
};
